import { find } from '../helpers';

const element = find('[data-aos]')

if (element) {
    import('./index')
}
